module.exports = __webpack_public_path__ + "static/media/Icon-Close-White.31dbbc6b.svg";